export default __webpack_public_path__ + "static/media/item_10_active.98854bb9.png";